// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerLineMenu__link__count":"fj_a bib_fm","SellerLineMenu__link--active":"fj_b bib_ee"};